import React from 'react';
import PropTypes from 'prop-types';
import Price from '../../Price';
import StockLabel from '../../StockLabel';

import { useTranslation } from 'react-i18next';

const CustomPageDetailContentEcLargeLayoutItem = (props) => {

  let {
    pageBlockItem,
  } = props;

  let {t} = useTranslation('application');

  return (
    <li className="col px-0">
      <figure className="img">
        <a target="_blank" href={pageBlockItem.itemUrl}>
          <span>
            <img className="m_imgShadow" src={pageBlockItem.itemImageUrl} alt=""/>
          </span>
        </a>
        {/*// ====== Disable modal support for first release
        <div className="m_previewBtn"><a data-toggle="modal"
                                          data-target={"#item_modal_" + pageBlockItem.pageBlockItemId}>プレビュー</a>
        </div>
        */}
      </figure>
      <div className="dtl">
        <p className="ttl"><span><a target="_blank" href={pageBlockItem.itemUrl}>{pageBlockItem.itemName}</a></span></p>
        <p className="subTxt"><a href={pageBlockItem.extendProperties.itemCompanyUrl}>{pageBlockItem.extendProperties.itemCompanyName}</a></p>
        <p className="price">
          {pageBlockItem.extendProperties.itemDiscounted &&
          <React.Fragment>
            <del><Price currency={'JPY'} price={pageBlockItem.extendProperties.itemDiscountedOriginalPrice} openPrice={pageBlockItem.extendProperties.openPrice}/></del>
            <br />
          </React.Fragment>
          }
          <span className={pageBlockItem.extendProperties.itemDiscounted ? "m_txt s_cpn" : "m_txt"}>
                <span className="em"><Price currency={'JPY'} price={pageBlockItem.extendProperties.itemPrice} openPrice={pageBlockItem.extendProperties.openPrice}/></span>
                <span className="sub ml-2">({t('item.taxIncluded')})</span>
              </span>
          {pageBlockItem.extendProperties.itemDiscounted && <span className="m_badge">10%OFF</span>}
        </p>
        <p className="label">{pageBlockItem.itemCategoryName}</p>

        {pageBlockItem.itemDescription && <p className="subTxt"  style={{whiteSpace: 'pre-wrap'}}>{pageBlockItem.itemDescription}</p> }
        {/*// ====== Disable modal support for first release
        <p className="m_btn s_default">
          <a data-toggle="modal" data-target={"#item_modal_" + pageBlockItem.pageBlockItemId}><i className="fa fa-search-plus"></i> このカタログをプレビュー</a>
        </p>
        */}
        <span className="subTxt"><StockLabel numberOfStocks={pageBlockItem.extendProperties.numberOfStocks} salesMethodMaker={pageBlockItem.extendProperties.salesMethodMaker} salesMethodLabel={pageBlockItem.extendProperties.salesMethodLabel}/></span>
        <p className="subTxt">{pageBlockItem.extendProperties.shippingDate}</p>
        {pageBlockItem.extendProperties.shopName &&
        <p>
          <a href={pageBlockItem.extendProperties.shopUrl}>
            <i className="c-fa-shop"></i>{pageBlockItem.extendProperties.shopName}
          </a>
        </p>
        }
        {pageBlockItem.extendProperties.itemBuyUrl &&
          <React.Fragment>
            <br/>
            <a className="btn btn-primary btn-block btn-lg text-wrap" target="_blank" href={pageBlockItem.extendProperties.itemBuyUrl}>
              <i className="c-fa-cart s_yellow"></i> {t('common.viewPurchase')}
            </a>
          </React.Fragment>
        }
      </div>
    </li>
  );

};

CustomPageDetailContentEcLargeLayoutItem.propTypes = {
  pageBlockItem: PropTypes.any.isRequired
};

export default CustomPageDetailContentEcLargeLayoutItem;
